import { render, staticRenderFns } from "./nav.vue?vue&type=template&id=2b0c2c40&scoped=true&"
import script from "./nav.vue?vue&type=script&lang=js&"
export * from "./nav.vue?vue&type=script&lang=js&"
import style0 from "./nav.vue?vue&type=style&index=0&id=2b0c2c40&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b0c2c40",
  null
  
)

export default component.exports